import create from 'zustand';
import { combine, persist } from 'zustand/middleware';

const adpWfnStore = combine({ type: '', key: '' }, set => ({
  updateType: (newType: string) => set(() => ({ type: newType })),
  updateKey: (newKey: string) => set(() => ({ key: newKey })),
}));

export const useAdpWfnStore = create(persist(adpWfnStore, { name: 'adpWfn' }));
